import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  HXCancellationGetAirlineDetailsReducer,
  HXCancellationCreateHXRuleReducer,
  AgencyBookingReportCreateRuleReducer,
  ScheudleChangeCreateSCRuleReducer,
  GetLogsReducer,
  CreateCustomerReducer,
  SendOTPReducer,
  UserLoginReducer,
  GetHXRulesReducer,
  GetAgencyBookingReportRulesReducer,
  GetSCRulesReducer,
  GetQueueListByPCCReducer,
  GetCustomersReducer,
  GetHXRuleByIDReducer,
  GetAgencyBookingReportRuleByIDReducer,
  GetSCRuleByIDReducer,
  GetCustomerByIDReducer,
  UpdateHXRuleReducer,
  UpdateAgencyBookingReportRuleReducer,
  UpdateSCRuleReducer,
  UpdateCustomerReducer,
  DeleteHXRuleReducer,
  DeleteAgencyBookingReportRuleReducer,
  DeleteSCRuleReducer,
  DeleteCustomerReducer,
  GetAllCountryReducer,
  GetUserByIDReducer,
  GetLoggedInUserReducer,
  UpdateUserReducer,
  ResetUserPasswordReducer,
  ChangeUserPasswordReducer,
  GetManageBookingDataReducer,
  PrintItineraryDataReducer,
  EmailItineraryDataReducer,
  GetAllUsersReducer,
  DeleteUserReducer,
  CreateUserReducer,
  GetProductsDataReducer,
  GetUserPermissionDataReducer,
  CheckPCCReducer,
  GetAllActiveCustomersReducer,
  GetAllActiveReportEnabledCustomersReducer,
  GetTicketReportDataReducer,
  GetTpBatchReportDataReducer,
  EmailMultiPccTicketReportReducer,
  GetCurrencyReducer,
  DownloadExcelFileReducer,
  DownloadCSVFileReducer,
  GetCustomerStaticDataByCustIDReducer,
  CreateCustomerLoginReducer,
  GetAllCustomerLoginsReducer,
  UpdateCustomerLoginsReducer,
  GetParentCustomersReducer,
  InvoiceDisplayReducer,
} from "../reducers/AdminReducer";
import { Download } from "@mui/icons-material";

const rootReducer = combineReducers({
  HXCancellationGetAirlineDetails: HXCancellationGetAirlineDetailsReducer,
  HXCancellationCreateHXRule: HXCancellationCreateHXRuleReducer,
  AgencyBookingReportCreateRule: AgencyBookingReportCreateRuleReducer,
  ScheudleChangeCreateSCRule: ScheudleChangeCreateSCRuleReducer,
  GetLogs: GetLogsReducer,
  CreateCustomer: CreateCustomerReducer,
  SendOTPData: SendOTPReducer,
  UserLogin: UserLoginReducer,
  GetHXRules: GetHXRulesReducer,
  GetAgencyBookingReportRules: GetAgencyBookingReportRulesReducer,
  GetSCRules: GetSCRulesReducer,
  GetQueueListByPCC: GetQueueListByPCCReducer,
  GetCustomers: GetCustomersReducer,
  GetHXRuleByID: GetHXRuleByIDReducer,
  GetAgencyBookingReportRuleByID: GetAgencyBookingReportRuleByIDReducer,
  GetSCRuleByID: GetSCRuleByIDReducer,
  GetCustomerByID: GetCustomerByIDReducer,
  UpdateHXRule: UpdateHXRuleReducer,
  UpdateAgencyBookingReportRule: UpdateAgencyBookingReportRuleReducer,
  UpdateSCRule: UpdateSCRuleReducer,
  UpdateCustomer: UpdateCustomerReducer,
  DeleteHXRule: DeleteHXRuleReducer,
  DeleteAgencyBookingReportRule: DeleteAgencyBookingReportRuleReducer,
  DeleteSCRule: DeleteSCRuleReducer,
  DeleteCustomer: DeleteCustomerReducer,
  GetAllCountry: GetAllCountryReducer,
  GetUserByID: GetUserByIDReducer,
  GetLoggedInUser: GetLoggedInUserReducer,
  UpdateUser: UpdateUserReducer,
  ResetUserPassword: ResetUserPasswordReducer,
  ChangeUserPassword: ChangeUserPasswordReducer,
  GetManageBookingData: GetManageBookingDataReducer,
  PrintItineraryData: PrintItineraryDataReducer,
  EmailItineraryData: EmailItineraryDataReducer,
  GetAllUsers: GetAllUsersReducer,
  DeleteUser: DeleteUserReducer,
  CreateUser: CreateUserReducer,
  GetProductsData: GetProductsDataReducer,
  GetUserPermissionData: GetUserPermissionDataReducer,
  CheckPCC: CheckPCCReducer,
  GetAllActiveCustomers: GetAllActiveCustomersReducer,
  GetAllActiveReportEnabledCustomers: GetAllActiveReportEnabledCustomersReducer,
  GetTicketReportData: GetTicketReportDataReducer,
  GetTpBatchReportData: GetTpBatchReportDataReducer,
  EmailMultiPccTicketReport: EmailMultiPccTicketReportReducer,
  GetCurrency: GetCurrencyReducer,
  DownloadExcelFile: DownloadExcelFileReducer,
  DownloadCSVFile: DownloadCSVFileReducer,
  GetCustomerStaticDataByCustID: GetCustomerStaticDataByCustIDReducer,
  CreateCustomerLogin: CreateCustomerLoginReducer,
  GetAllCustomerLogins: GetAllCustomerLoginsReducer,
  UpdateCustomerLogins: UpdateCustomerLoginsReducer,
  GetParentCustomers: GetParentCustomersReducer,
  InvoiceDisplay: InvoiceDisplayReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
